export default __webpack_public_path__ + "static/media/rating-solid-watch-filled.9db79dfd.svg";